import { Component, Inject, OnInit, Optional } from '@angular/core';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { Item } from '@app/core/components/listbox/listbox.component';
import { Base64UrlService } from '@app/services/base64url.service';
import { SrOperationGet, SrOperationService } from '@app/services/sr-operation.service';

@Component({
    selector: 'tt-sr-operation',
    templateUrl: './sr-operation.component.html',
    styleUrls: ['./sr-operation.component.css'],
    standalone: false,
})
export class SrOperationComponent implements OnInit {
    public page?: SrOperationGet;
    public resources: Item[] = [];
    public reports: Item[] = [];
    public view = 'BASIC';

    constructor(
        private readonly operation: SrOperationService,
        private readonly base64: Base64UrlService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator,
    ) { this.navigator = useNavigatorFor(navigator, this); }

    public async ngOnInit(): Promise<void> {
        this.page = await this.operation.getOperation({ custact_no: String(this.navigator?.params['custact_no'] ?? '') });
        if (!this.page.custact_no?.trim()) return;
        const params = { custact_no: this.page.custact_no };
        [this.resources, this.reports] = await Promise.all([this.operation.getResources(params), this.operation.getReports(params)]);
    }

    public openMap(field: 'maplink_external' | 'maplink_external_mtbmap'): void {
        if (this.page) window.open(this.base64.urlDecode(this.page[field]));
    }
}
